module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/1-active-a01157bc0801e6ea099b1e2d76ba6ac1.png";